"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Donut = void 0;
var _react = require("react");
var _Donut = _interopRequireDefault(require("./Donut.styles"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var calcCircleSizeParams = function calcCircleSizeParams(size) {
  var width;
  var stokeWidth;
  if (size === 'small') {
    width = 100;
    stokeWidth = 4;
  } else if (size === 'medium') {
    width = 128;
    stokeWidth = 5;
  } else {
    width = 156;
    stokeWidth = 6;
  }
  var radius = width / 2 - stokeWidth * 2;
  var circumference = 2 * Math.PI * radius;
  return {
    width: width,
    stokeWidth: stokeWidth,
    radius: radius,
    circumference: circumference
  };
};
var getValidProps = function getValidProps(props) {
  var minProp = props.min,
    maxProp = props.max,
    valueProp = props.value;
  var validMin = minProp;
  var validMax = maxProp;
  var validValue = valueProp;
  if (valueProp < minProp) {
    validValue = minProp;
  }
  if (valueProp > maxProp) {
    validValue = maxProp;
  }
  return _objectSpread(_objectSpread({}, props), {}, {
    min: validMin,
    max: validMax,
    value: validValue
  });
};
var Donut = function Donut(props) {
  var _getValidProps = getValidProps(props),
    min = _getValidProps.min,
    max = _getValidProps.max,
    value = _getValidProps.value,
    unit = _getValidProps.unit,
    _getValidProps$circle = _getValidProps.circleSize,
    circleSize = _getValidProps$circle === void 0 ? 'medium' : _getValidProps$circle;
  var circleParams = (0, _react.useMemo)(function () {
    return calcCircleSizeParams(circleSize);
  }, [circleSize]);
  var maxAngle = (0, _react.useMemo)(function () {
    return Math.round(value * 360 / (max - min));
  }, [max, min, value]);
  var requestAnimationRef = (0, _react.useRef)();
  var currentAnimatedAngle = (0, _react.useRef)(0);
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    animatedValue = _useState2[0],
    setAnimatedValue = _useState2[1];
  var _useState3 = (0, _react.useState)("0, ".concat(circleParams.circumference)),
    _useState4 = _slicedToArray(_useState3, 2),
    strokeDasharray = _useState4[0],
    setStrokeDasharray = _useState4[1];
  var styles = (0, _Donut.default)(circleParams.width, circleParams.stokeWidth, unit);
  var updateValues = (0, _react.useCallback)(function () {
    var angleIncrement = currentAnimatedAngle.current < maxAngle ? 4 : -4;
    var percentage = currentAnimatedAngle.current / 360 * 100;
    var angleStroke = Math.round(circleParams.circumference * percentage / 100);
    setStrokeDasharray(angleStroke + ', ' + circleParams.circumference);
    if (Math.abs(maxAngle - currentAnimatedAngle.current) >= Math.abs(angleIncrement)) {
      setAnimatedValue(Math.round((max - min) * percentage / 100));
      currentAnimatedAngle.current += angleIncrement;
      requestAnimationRef.current = window.requestAnimationFrame(updateValues);
    } else {
      setAnimatedValue(value);
    }
  }, [circleParams.circumference, min, max, value, maxAngle]);
  (0, _react.useEffect)(function () {
    if (requestAnimationRef.current) {
      cancelAnimationFrame(requestAnimationRef.current);
    }
    updateValues();
    return function () {
      if (requestAnimationRef.current) {
        cancelAnimationFrame(requestAnimationRef.current);
      }
    };
  }, [maxAngle, updateValues]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: styles['cc-Donut'],
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
      viewBox: "0 0 ".concat(circleParams.width, " ").concat(circleParams.width),
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        className: styles['cc-Donut__background-circle'],
        r: circleParams.radius
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("circle", {
        className: styles['cc-Donut__value-circle'],
        r: circleParams.radius,
        strokeDasharray: strokeDasharray
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: styles['cc-Donut__text'],
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Donut__text__value'],
        children: animatedValue
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: styles['cc-Donut__text__unit'],
        children: unit
      })]
    })]
  });
};
exports.Donut = Donut;